export default import.meta.ROLLDOWN_FILE_URL_lUrRy5FFg4ugUpMBt$Ob5Q